const list = {
  // =================================================================================================================
  components() {
    return [
      // ===========[ 날짜 관련 ]==========
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["사업장명", "대상년도", "재해건수<br>(전년도)", "중대재해발생<br>여부확인서", "원천징수이행<br>상황신고서", "산재요양승인<br>반려여부확인서", "안전보건조직도", "안전보건<br>경영방침", "안전보건 관리규정", "승인여부"],
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getCol: (index, value, func) => {
    try {
      if (func._getCol) {
        if (index === 2) {
          return func.getContent(value).대상정보.업체명 ? func.getContent(value).대상정보.업체명.com_name : "";
        } else if (index >= 5 && index <= 10) {
          const key = func._getCol(index, value, func);
          const color = {
            "@08": "#28C76F",
            "@0A": "#EA5455",
            "@EB@": "#696D71",
          };
          const data = {
            "@08": "통과",
            "@0A": "미통과",
            "@EB@": "해당없음",
          };
          return {
            type: "html",
            html: `<span style="color:${color[key]}">${data[key] || ""}</span>`,
          };
        } else {
          const data = func._getCol(index, value, func);
          return data;
        }
      }
    } catch (e) {}
    return "";
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "업체명",
        key: "body.대상정보.업체명",
      },
      {
        name: "사업자등록번호",
        key: "body.대상정보.사업자등록번호",
        style: { minWidth: "150px" },
      },
      {
        name: "재해건수<br>(전년도)",
        key: "body.대상정보.재해건수",
      },
      {
        name: "중대재해발생<br>여부확인서",
        key: "body.필수제출서류.중대재해발생여부확인서",
      },
      {
        name: "원천징수이행<br>상황신고서",
        key: "body.필수제출서류.원천징수이행상황신고서",
      },
      {
        name: "산재요양승인<br>반려여부확인서",
        key: "body.필수제출서류.산재요양승인반려여부확인서",
        style: { minWidth: "120px" },
      },
      {
        name: "안전보건조직도",
        key: "body.필수제출서류.안전보건조직도",
        style: { minWidth: "120px" },
      },
      {
        name: "안전보건<br>경영방침",
        key: "body.필수제출서류.안전보건경영방침",
      },
      {
        name: "안전보건 관리규정",
        key: "body.필수제출서류.안전보건관리규정",
        style: { minWidth: "130px" },
      },
      {
        name: "승인여부",
        key: "body.대상정보.승인여부",
      },
    ];
  },
};

export default list;
